import React from 'react';
import { PackageIcon, UsersIcon, StarIcon } from 'lucide-react';
export function TrustMetrics() {
  const metrics = [{
    icon: PackageIcon,
    value: '+5,000',
    label: 'Envíos realizados',
    color: 'text-blue-900'
  }, {
    icon: UsersIcon,
    value: '+500',
    label: 'Clientes satisfechos',
    color: 'text-red-600'
  }, {
    icon: StarIcon,
    value: '4.9/5',
    label: 'Calificación promedio',
    color: 'text-blue-900'
  }];
  return <section className="w-full bg-gray-50 py-16 md:py-20" data-id="element-217">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-219">
          {metrics.map((metric, index) => {
          const Icon = metric.icon;
          return <div key={index} className="text-center" data-id="element-220">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-4" data-id="element-221">
                  <Icon className={`h-8 w-8 ${metric.color}`} data-id="element-222" />
                </div>
                <div className="text-4xl md:text-5xl font-bold text-gray-900 mb-2" data-id="element-223">
                  {metric.value}
                </div>
                <div className="text-lg text-gray-600 font-medium" data-id="element-224">
                  {metric.label}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}